import angular from 'angular';
import template from './marketing-report.html';
import MarketingReportController from './marketing-report.controller';
import MarketingReportDirective from './MarketingReport.directive';

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state('drivecoach.admin.marketingreport', {
        url: '/marketing-report',
        controller: MarketingReportController,
        controllerAs: 'vm',
        template: template,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];

export default angular
    .module('admin.marketingreport', [MarketingReportDirective.name])
    .config(config)
    .controller('MarketingReportController', MarketingReportController);
